import { UpdateStoryDiscussionCommentMeta, UpdateStoryDiscussionCommentPayload } from 'types/store/UpdateStoryDiscussionComment';
import { createAsyncReducer } from 'utils/Redux';

import { updateStoryDiscussionCommentActions } from '../actions';

export default createAsyncReducer<UpdateStoryDiscussionCommentMeta, UpdateStoryDiscussionCommentPayload>(updateStoryDiscussionCommentActions);
